import { DatabaseInstanceType } from '@amzn/awscat-portfolio-assessment-types';

import { constants } from '../../../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../../../common/table/types';
import { getCell } from '../../../common/awsui-table-helper';

export const recommendationSummaryTableColumns: ColumnDefinition<DatabaseInstanceType>[] = [
    {
        id: 'instanceType',
        type: ColumnTypes.TEXT,
        header: constants.INSTANCE_TYPE,
        data: item => item.instanceType ?? '-',
        cell: item => item.instanceType ?? '-',
    },
    {
        id: 'cpu',
        type: ColumnTypes.NUMBER,
        header: constants.V_CPU,
        data: item => item.cpu ?? '-',
        cell: item => getCell(item.cpu ?? '-'),
    },
    {
        id: 'memory',
        type: ColumnTypes.NUMBER,
        header: constants.MEMORY,
        data: item => item.memory,
        cell: item => getCell(item.memory ?? '-'),
    },
    {
        id: 'databaseEngine',
        type: ColumnTypes.TEXT,
        header: constants.TARGET_DB_ENGINE,
        data: item => item.databaseEngine ?? '-',
        cell: item => item.databaseEngine ?? '-',
    }, 
    {
        id: 'databaseEdition',
        type: ColumnTypes.TEXT,
        header: constants.EDITION,
        data: item => item.databaseEdition ?? '-',
        cell: item => item.databaseEdition ?? '-',
    },
    {
        id: 'numInstances',
        type: ColumnTypes.NUMBER,
        header: constants.COUNT,
        data: item => item.numInstances ?? '-',
        cell: item => getCell(item.numInstances ?? '-')
    }
];
